module.exports = __webpack_public_path__ + "static/Dental implants smile before-0279ca131318d5da2730c5596bd8b8c0.jpg";